module.exports = require("history");


//////////////////
// WEBPACK FOOTER
// external "history"
// module id = 16
// module chunks = 0 1